import { tv } from "@kirvanobr/theme";

export const styles = tv({
  slots: {
    base: "h-3 w-5 rounded-full bg-foreground-400 p-0.5 animate-gray-to-primary flex-shrink-0",
    ball: "bg-background rounded-full w-[8px] h-[8px] absolute animate-move-right-left",
  },
});
